const steps = [
  {
    number: "01",
    title: "CONSULTATION",
    description:
      "We start with a thorough conversation about your situation, goals, and existing coverage — no assumptions, no shortcuts.",
  },
  {
    number: "02",
    title: "RISK ASSESSMENT",
    description:
      "Our advisors identify exposures and gaps that generic policies often miss — building a complete picture of your risk profile.",
  },
  {
    number: "03",
    title: "TAILORED PROPOSAL",
    description:
      "We present coverage options matched to your needs and budget — clearly explained, without pressure or jargon.",
  },
  {
    number: "04",
    title: "ONGOING SUPPORT",
    description:
      "Our relationship doesn't end at policy issuance — we're here for renewals, changes, and claims every step of the way.",
  },
];

function Step({ step, className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <div
        className="flex items-center justify-center rounded-full font-cinzel font-bold text-white flex-shrink-0"
        style={{
          width: "clamp(40px, 5vw, 56px)",
          height: "clamp(40px, 5vw, 56px)",
          backgroundColor: "#012E72",
          fontSize: "clamp(12px, 1.5vw, 16px)",
          letterSpacing: "0.04em",
        }}
      >
        {step.number}
      </div>

      <div className="mt-5 md:mt-7">
        <h3
          className="font-cinzel font-bold uppercase"
          style={{
            color: "#012E72",
            fontSize: "clamp(14px, 2vw, 22px)",
            lineHeight: "1.1",
            marginBottom: "10px",
          }}
        >
          {step.title}
        </h3>

        <p
          className="font-times"
          style={{
            color: "#1B1B1B",
            fontSize: "clamp(13px, 1.4vw, 16px)",
            lineHeight: "1.5",
          }}
        >
          {step.description}
        </p>
      </div>
    </div>
  );
}

export default function FourStepsSection() {
  return (
    <section
      className="w-full overflow-hidden"
      style={{
        background:
          "radial-gradient(ellipse at bottom left, #012E72 0%, #3a5fa8 1%, #a8bfe8 26%, #ffffff 50%)",
        padding: "clamp(40px, 8vw, 90px) clamp(20px, 6vw, 90px)",
      }}
    >
      {/* HEADER */}
      <div style={{ marginBottom: "clamp(40px, 7vw, 80px)" }}>
        <div className="flex items-center gap-3 mb-4">
          <div style={{ width: "28px", height: "1px", backgroundColor: "#012E72" }} />
          <span
            className="font-cinzel uppercase"
            style={{
              color: "#012E72",
              fontSize: "clamp(10px, 1.2vw, 14px)",
              letterSpacing: "0.08em",
            }}
          >
            HOW IT WORKS
          </span>
        </div>

        <h2
          className="font-cinzel"
          style={{
            color: "#012E72",
            fontSize: "clamp(36px, 7vw, 74px)",
            lineHeight: "0.95",
            fontWeight: "700",
          }}
        >
          <span className="italic font-normal" style={{ fontFamily: "Constantia" }}>
            Four
          </span>{" "}
          Steps to
          <br />
          Complete{" "}
          <span className="italic font-normal" style={{ fontFamily: "Constantia" }}>
            Coverage
          </span>
        </h2>
      </div>

      {/* STEPS — 2-col on md+, 1-col on mobile */}
      <div className="w-full max-w-[980px]">

        {/* Mobile: single column */}
        <div className="flex flex-col gap-10 md:hidden">
          {[steps[0], steps[1], steps[3], steps[2]].map((step) => (
            <Step key={step.number} step={step} />
          ))}
        </div>

        {/* Desktop: 2x2 grid */}
        <div className="hidden md:grid grid-cols-2" style={{ gap: "clamp(24px, 4vw, 48px) clamp(16px, 3vw, 32px)" }}>
          <Step step={steps[0]} />
          <Step step={steps[1]} className="pl-6 lg:pl-10" />
          <Step step={steps[3]} className="pt-2" />
          <Step step={steps[2]} className="pl-6 lg:pl-10 pt-2" />
        </div>

      </div>
    </section>
  );
}